import React from 'react';
import numberHelper from '../../util/numberFormatter'
import { Link } from 'react-router-dom'
import CartItemButton from './CartItemButton';

const ProductList = props => {
  if (!props.data) {
    return (
      <div className={'LoadingPane'}>Loading...</div>
    );
  }

  if (props.data.length === 0) {
    return (
      <div>
        No products...
      </div>
    )
  }

  return (
    <ul className="DataList ProductList">
      {
        props.data.map(item => {
          return (
            <li key={item.key}>
              <strong>{item.name}</strong>
              {
                (props.mode === 'edit') ?
                  <Link to={`/product/edit/${item.key}`}><i className="icon ion-md-more"></i></Link>
                  :
                  <CartItemButton product={item} type='add' />
              }
              <span>{numberHelper.Formatter.toDecimalTrim(item.price)} {item.currency}</span>
            </li>
          )
        })
      }
    </ul>
  )
}

export default ProductList
